import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="bg-brand-darkGreen text-white py-16 px-4" data-id="element-146">
      <div className="max-w-3xl mx-auto" data-id="element-147">
        <motion.h2 className="text-3xl md:text-4xl font-bold mb-10 text-center leading-tight" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-148">
          <span className="text-4xl mr-2" data-id="element-149">💥</span>
          Si sos mamá (o estás a cargo de las viandas), seguro te pasa esto:
        </motion.h2>

        <div className="space-y-4 mb-10 text-lg md:text-xl font-medium bg-white/10 p-8 rounded-2xl border border-white/20" data-id="element-150">
          {['No sabés qué mandar todos los días', 'Terminás repitiendo siempre lo mismo', 'Tenés poco tiempo para cocinar', 'Querés que coman mejor, pero no sabés cómo', 'Las verduras vuelven intactas', 'Te cansás de pensar más que de cocinar'].map((point, index) => <motion.div key={index} className="flex items-start gap-4" initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} data-id="element-151">
              <span className="text-brand-red text-2xl font-bold" data-id="element-152">❌</span>
              <p data-id="element-153">{point}</p>
            </motion.div>)}
        </div>

        <motion.p className="text-2xl md:text-3xl font-bold text-center text-brand-yellow" initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-154">
          Y lo peor: todos los días empieza de cero otra vez
        </motion.p>
      </div>
    </section>;
}